import { Leerkr8Objective } from '@core/saves/leerkr8/types';
import { getDefaultSaveState, ISavesManager, ISaveState } from '@core/saves/saves.interface';
import { Observable, Subject } from 'rxjs';

export class OfflineSaverService implements ISavesManager {
  private playerCode?: string;
  private _isLoggedIn = false;
  private onLoginSubject = new Subject<string>();
  onLogin$: Observable<string> = this.onLoginSubject.asObservable();

  addPlaythroughObjective(objectives: Leerkr8Objective): void {}

  async startPolling(): Promise<void> {}

  async stopPolling(): Promise<void> {}

  isLoggedIn() {
    return this._isLoggedIn;
  }

  async save(state: Partial<ISaveState>): Promise<void> {
    if (!this.playerCode) {
      throw new Error('Not logged in');
    }

    const oldSave = await this.load();

    const finalState = { ...oldSave, ...state } as ISaveState;
    localStorage.setItem(`save-${btoa(this.playerCode)}`, JSON.stringify(finalState));
  }

  async load(): Promise<ISaveState> {
    if (!this.playerCode) {
      throw new Error('Not logged in');
    }

    const save = localStorage.getItem(`save-${btoa(this.playerCode)}`);
    if (save) {
      return JSON.parse(save);
    }

    return getDefaultSaveState();
  }

  async login(playerCode: string): Promise<void> {
    this.playerCode = playerCode;
    this._isLoggedIn = true;
    this.onLoginSubject.next(playerCode);
    return;
  }

  logout() {
    this.playerCode = undefined;
    this._isLoggedIn = false;
  }
}
